import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  AppointmentService,
  AppointObj,
} from "../../model/backoffice/appointment";
import { FormObjectService } from "../../core/FieldObject";
import {
  DefaultBillViewer,
  DefaultEditorValue,
  GetEditorForm,
  ShowsEditor,
} from "../../core/Helper2";
import {
  BranchDocuService,
  GetDocuRunningFormat,
} from "../../model/backoffice/docubranch";
import { SearchCustomer } from "../../model/customer";
import { SearchBranchPatientRight } from "../../model/patient-right";
import { SearchPatient } from "../../model/backoffice/patient";
import FormAutoObject from "../../core/FormAutoObject";
import { AlertError, AlertOK } from "../../core/Helper";
import BillViewer, {
  FormDocuType,
} from "../../components/bill-forms/BillViewer";
import SearchBigData, { DefaultState } from "../components/SearchBigData";
import { FormType } from "../../model/backoffice/document-type";
import PatientEditor from "../back-office-forms/005_patient-editor";
import { SearchModalityPart } from "../../model/goods";
import { SearchRadi } from "../../model/staff";
import SearchTypeB from "../components/SearchTypeB";

export default function TechAppointmentEditor(props) {
  const documentIdFieldName = "AppointId";
  const userInfo = useSelector((state) => state.user.detail);
  const [objField, setObjField] = useState([]);
  const [data, setData] = props.data;
  const [form, setForm] = useState(null);
  const [editor, setEditor] = props.editor;
  const [addPatient, setAddPatient] = useState(DefaultEditorValue);
  const [searchB, setSearchB] = useState(DefaultState);
  const [searchBig, setSearchBig] = useState(DefaultState);
  const [docuList, setDocuList] = useState();
  const [curDocu, setCurDocu] = useState();

  const [billViewer, setBillViewer] = useState(DefaultBillViewer);
  const refForm1 = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("Editor Info", editor);
    if (editor?.show) {
      loadSelectorGroup();
      loadDocuList([userInfo, setDocuList]);
      setBillViewer(DefaultBillViewer);
      buildForm();
      if (editor?.idValue > 0) {
        getOldData();
      }

      return () => {
        clearObject();
      };
    }
  }, [editor?.show]);

  useEffect(() => {
    if (editor?.show) {
      buildForm();
    }
  }, [docuList]);

  useEffect(() => {
    if (data?.BranchDocu) {
      getCurdocu([data?.BranchDocu, userInfo, setCurDocu]);
    }
  }, [data?.BranchDocu]);

  useEffect(() => {
    if (curDocu && editor?.show) {
      if (!data[documentIdFieldName]) {
        setData((pv) => ({ ...pv, DocuNo: GetDocuRunningFormat(curDocu) }));
      }
    }
  }, [curDocu]);

  const clearObject = () => {
    setData([]);
    setForm(null);
    setObjField(null);
    setSearchBig(null);
    setSearchB(null);
    setDocuList(null);
    setBillViewer(null);
  };

  /** ดึงข้อมูลเก่า */
  const getOldData = async () => {
    let ret = await AppointmentService.GetItem(
      { [editor.idFieldName]: editor.idValue },
      userInfo
    );
    if (ret) {
      setData(ret);
    }
  };

  const patientClick = (item) => {
    SearchPatient([setSearchBig, data, setData, userInfo, item]);
  };
  const goodClick = (item) => {
    SearchModalityPart([setSearchBig, data, setData, userInfo, item]);
  };
  const physicianClick = (item) => {
    SearchRadi([setSearchBig, data, setData, userInfo, item, true]);
  };
  const customerClick = (item) => {
    SearchCustomer([setSearchBig, data, setData, userInfo, item]);
  };

  const rightClick = (item) => {
    SearchBranchPatientRight([setSearchBig, data, setData, userInfo, item]);
  };

  /** Build Form objects */
  const buildForm = async () => {
    setObjField(
      await FormObjectService.BuildsFormOBJs(
        AppointObj({
          docuList: docuList,
          patientClick,
          goodClick,
          physicianClick,
          customerClick,
          rightClick,
        })
      )
    );
  };

  /** แสดงฟอร์ม */
  useEffect(() => {
    if (objField) {
      renderForm();
    }
  }, [objField, data]);

  /** Render form */
  const renderForm = async () => {
    setForm(
      <FormAutoObject
        {...{ items: objField, dataValue: [data, setData], refTo: refForm1 }}
      />
    );
  };

  const loadSelectorGroup = async () => {};
  const actionSave = async () => {
    let fData1 = {
      ...data,
      [editor.idFieldName]: editor.idValue,
      DocuBranch: curDocu,
    };

    let ret = await AppointmentService.SaveItem(fData1, userInfo);

    if (ret) {
      if (ret?.Message == "Error") {
        AlertError(ret?.Data ?? "พบปัญหาการบันทึก", dispatch);
        return;
      }
      AlertOK("บันทึกสมบูรณ์", dispatch);
      // editor.action();
    }
  };

  /** เพิ่มคนไข้ใหม่ */
  const onAddPatient = () => {
    ShowsEditor(setAddPatient, "PatientId", 0, () => {});
  };

  /** Print  */
  const doPrint = () => {
    setBillViewer((pv) => ({
      ...pv,
      show: true,
      formDocuType: FormDocuType.APPOINT,
    }));
  };

  return (
    <>
      <GetEditorForm
        {...{
          title: "เพิ่ม/แก้ไขตารางนัดตรวจ",
          form: [form, setForm],
          editor: [editor, setEditor],
          saveData: actionSave,
          print: {
            action: doPrint,
            disabled: false,
            hidden: data[editor?.idFieldName] === 0,
          },
        }}
      />
      <SearchTypeB {...{ winState: [searchB, setSearchB] }} />
      <SearchBigData
        {...{
          winState: [searchBig, setSearchBig],
          disableEmpty: true,
          onAddNew: onAddPatient,
        }}
      />
      <PatientEditor {...{ editor: [addPatient, setAddPatient] }} />
      <BillViewer
        {...{ billViewer: [billViewer, setBillViewer], data: [data, setData] }}
      />
    </>
  );
}

const loadDocuList = async ([userInfo, setDocuList]) => {
  let docus = await BranchDocuService.GetList(
    {
      text: null,
      root:
        "brchid=" +
        userInfo.brchid +
        " and docu_direction=" +
        FormType.APPOINTMENT,
    },
    userInfo
  );

  setDocuList(docus ?? []);
};

const getCurdocu = async ([BranchDocu, userInfo, setCurDocu]) => {
  let bDocu = await BranchDocuService.GetRunningNumber(
    {
      DocuBrchId: BranchDocu?.DocuBrchId, // ส่งรหัสเอกสารสาขา
    },
    userInfo
  );
  setCurDocu(bDocu);
};
